import React from "react";

export default function Footer() {
  return (
    <footer className="text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col md:flex-row justify-between items-center">
        <div className="flex flex-col md:flex-row items-center md:space-x-4">
          <span>© 2023 YOKS RENT A CAR</span>
        </div>
        <div className="flex space-x-4 mt-4 md:mt-0">
          <a className="text-orange-300 hover:text-orange-500" href="#">
            Terms
          </a>
          <a className="text-orange-300 hover:text-orange-500" href="#">
            FAQ
          </a>
        </div>
        <div className="flex items-center space-x-4 mt-4 md:mt-0">
          <button className="flex text-white">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 2.64062C10.9511 2.64062 8.94823 3.24819 7.24464 4.38649C5.54105 5.5248 4.21327 7.14271 3.42919 9.03564C2.64511 10.9286 2.43996 13.0115 2.83968 15.021C3.2394 17.0305 4.22604 18.8764 5.67482 20.3252C7.1236 21.774 8.96947 22.7606 10.979 23.1603C12.9885 23.56 15.0714 23.3549 16.9644 22.5708C18.8573 21.7867 20.4752 20.459 21.6135 18.7554C22.7518 17.0518 23.3594 15.0489 23.3594 13C23.3562 10.2535 22.2637 7.62044 20.3216 5.67838C18.3796 3.73632 15.7465 2.64385 13 2.64062ZM13 22.1406C11.1922 22.1406 9.42491 21.6045 7.92175 20.6001C6.41858 19.5958 5.247 18.1682 4.55517 16.498C3.86334 14.8277 3.68232 12.9899 4.03501 11.2168C4.38771 9.44364 5.25827 7.81494 6.53661 6.5366C7.81495 5.25826 9.44365 4.3877 11.2168 4.03501C12.9899 3.68232 14.8277 3.86333 16.498 4.55516C18.1682 5.247 19.5958 6.41857 20.6002 7.92174C21.6045 9.42491 22.1406 11.1922 22.1406 13C22.1379 15.4234 21.174 17.7468 19.4604 19.4604C17.7468 21.174 15.4234 22.1379 13 22.1406ZM19.2969 13C19.2969 13.1616 19.2327 13.3166 19.1184 13.4309C19.0041 13.5452 18.8491 13.6094 18.6875 13.6094H13C12.8384 13.6094 12.6834 13.5452 12.5691 13.4309C12.4548 13.3166 12.3906 13.1616 12.3906 13V7.3125C12.3906 7.15088 12.4548 6.99589 12.5691 6.88161C12.6834 6.76733 12.8384 6.70312 13 6.70312C13.1616 6.70312 13.3166 6.76733 13.4309 6.88161C13.5452 6.99589 13.6094 7.15088 13.6094 7.3125V12.3906H18.6875C18.8491 12.3906 19.0041 12.4548 19.1184 12.5691C19.2327 12.6834 19.2969 12.8384 19.2969 13Z"
                fill="white"
              />
            </svg>
            24/7 Services
          </button>
          <button className="flex text-white">
            <svg
              fill="#fff"
              height="20px"
              width="20px"
              version="1.1"
              id="Layer_1"
              viewBox="0 0 368.666 368.666"
            >
              <g id="XMLID_2_">
                <g>
                  <g>
                    <path
                      d="M184.333,0C102.01,0,35.036,66.974,35.036,149.297c0,33.969,11.132,65.96,32.193,92.515
          c27.27,34.383,106.572,116.021,109.934,119.479l7.169,7.375l7.17-7.374c3.364-3.46,82.69-85.116,109.964-119.51
          c21.042-26.534,32.164-58.514,32.164-92.485C333.63,66.974,266.656,0,184.333,0z M285.795,229.355
          c-21.956,27.687-80.92,89.278-101.462,110.581c-20.54-21.302-79.483-82.875-101.434-110.552
          c-18.228-22.984-27.863-50.677-27.863-80.087C55.036,78.002,113.038,20,184.333,20c71.294,0,129.297,58.002,129.296,129.297
          C313.629,178.709,304.004,206.393,285.795,229.355z"
                    />
                    <path
                      d="M184.333,59.265c-48.73,0-88.374,39.644-88.374,88.374c0,48.73,39.645,88.374,88.374,88.374s88.374-39.645,88.374-88.374
          S233.063,59.265,184.333,59.265z M184.333,216.013c-37.702,0-68.374-30.673-68.374-68.374c0-37.702,30.673-68.374,68.374-68.374
          s68.373,30.673,68.374,68.374C252.707,185.341,222.035,216.013,184.333,216.013z"
                    />
                    {/* Horizontal line centered */}
                    <line
                      x1="20%"
                      y1="50%"
                      x2="80%"
                      y2="50%"
                      stroke="#000"
                      strokeWidth="2"
                    />
                  </g>
                </g>
              </g>
            </svg>
            ACCRA
          </button>
          <button className="flex rounded-full text-white text-lg bg-[#ED8B00] px-4 py-2 justify-center items-center space-x-2">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1_466)">
                <path
                  d="M8.00003 0.888672C6.59359 0.888672 5.21873 1.30573 4.04931 2.08711C2.87989 2.86849 1.96844 3.97909 1.43022 5.27848C0.891997 6.57786 0.751173 8.00767 1.02556 9.38709C1.29994 10.7665 1.97721 12.0336 2.97172 13.0281C3.96622 14.0226 5.2333 14.6999 6.61272 14.9743C7.99214 15.2486 9.42195 15.1078 10.7213 14.5696C12.0207 14.0314 13.1313 13.1199 13.9127 11.9505C14.6941 10.7811 15.1111 9.40623 15.1111 7.99978C15.1111 6.1138 14.3619 4.30506 13.0283 2.97147C11.6948 1.63788 9.88601 0.888672 8.00003 0.888672ZM5.49781 2.37312L6.30225 3.17756C6.39106 3.2653 6.46154 3.36981 6.5096 3.48502C6.55767 3.60023 6.58237 3.72384 6.58225 3.84867V5.03978C6.58295 5.16431 6.55895 5.28773 6.51166 5.40292C6.46436 5.51812 6.3947 5.62279 6.3067 5.71089L5.24448 6.77312C5.06874 6.94791 4.92921 7.15565 4.83387 7.38444C4.73854 7.61324 4.68929 7.85859 4.68892 8.10645V8.81312C4.69017 9.02062 4.62353 9.22284 4.49916 9.38894C4.37478 9.55504 4.1995 9.67591 4.00003 9.73312L2.26225 10.222C1.68633 8.74887 1.70135 7.11027 2.30416 5.64794C2.90698 4.18561 4.05106 3.01244 5.49781 2.37312ZM2.6667 11.1109L4.24003 10.6665C4.63483 10.5514 4.98187 10.3118 5.22937 9.98345C5.47687 9.65506 5.61157 9.25544 5.61336 8.84423V8.11534C5.61325 7.9905 5.63795 7.86689 5.68601 7.75168C5.73408 7.63647 5.80456 7.53197 5.89336 7.44423L6.95559 6.38201C7.13132 6.20722 7.27086 5.99948 7.36619 5.77068C7.46152 5.54189 7.51078 5.29653 7.51114 5.04867V3.84867C7.51078 3.60081 7.46152 3.35546 7.36619 3.12666C7.27086 2.89787 7.13132 2.69013 6.95559 2.51534L6.49336 2.03089C7.29239 1.82424 8.12492 1.7811 8.94103 1.90406C9.75714 2.02701 10.54 2.31353 11.2427 2.74642C11.9454 3.17931 12.5534 3.74967 13.0302 4.42327C13.5071 5.09688 13.843 5.85986 14.0178 6.66645L12.4445 6.93312C11.8428 7.03221 11.3029 7.36031 10.9378 7.84867L10.3645 8.60867C10.1987 8.82946 10.0843 9.08452 10.0297 9.35519C9.97508 9.62586 9.98166 9.90531 10.0489 10.1731C10.1132 10.4254 10.0887 10.6922 9.97939 10.9286C9.87012 11.1649 9.68279 11.3564 9.44892 11.4709C9.16068 11.6069 8.90815 11.8083 8.71141 12.0591C8.51466 12.3098 8.37913 12.603 8.31559 12.9153L8.0667 14.1553C6.97903 14.1641 5.90806 13.8877 4.96057 13.3535C4.01308 12.8193 3.22217 12.0461 2.6667 11.1109ZM9.05781 14.0798L9.24892 13.1198C9.28537 12.9484 9.36199 12.7881 9.47248 12.6521C9.58297 12.5161 9.72418 12.4083 9.88448 12.3376C10.312 12.127 10.654 11.7757 10.8531 11.3427C11.0522 10.9097 11.0962 10.4214 10.9778 9.95978C10.9439 9.82892 10.9403 9.69205 10.9672 9.55958C10.9942 9.42712 11.051 9.30254 11.1334 9.19534L11.7067 8.43534C11.9219 8.14507 12.2399 7.94794 12.5956 7.88423L14.12 7.63089C14.1971 9.13186 13.7282 10.61 12.8002 11.7921C11.8721 12.9743 10.5475 13.7806 9.07114 14.062L9.05781 14.0798Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_1_466">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
            English
          </button>
        </div>
      </div>
    </footer>
  );
}
